module.exports = __webpack_public_path__ + "h5/img/cygn5.d5b21f21.png";